import Vue from 'vue'
import '../assets/styles/element-variables.scss'
import {
  Button,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Cascader,
  Option,
  Loading,
  Link,
  MessageBox,
  Message,
  Notification,
  Menu,
  MenuItem,
  Submenu,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Pagination,
  DatePicker,
  Upload,
  Popover,
  Tag,
  Radio,
  RadioGroup,
  Row,
  Col,
  Image,
  Rate,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Steps,
  Step

} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Select)
Vue.use(Option)
Vue.use(Loading.directive)
Vue.use(Link)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Submenu)
Vue.use(Pagination)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Popover)
Vue.use(Tag)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Cascader)
Vue.use(Image)
Vue.use(Rate)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Steps)
Vue.use(Step)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
